import { connect } from 'react-redux';
import { withLastLocation } from 'react-router-dom-last-location';
import withPGTranslation from '../../../config/withPGTranslation';
import { clearApplicationError } from '../../../actions/aplication_error';
import SomeOtherAdvisors from './some_other_advisors';

const mapStateToProps = ({
  applicationError
}, {
  location: { pathname }
}) => ({
  ...applicationError,
  pathname
});

export default  withLastLocation(withPGTranslation(connect(mapStateToProps, {
  clearApplicationError
})(SomeOtherAdvisors)));
